import {LeftOutlined, RightOutlined} from '@ant-design/icons'
import {Button} from 'antd'
import {useDiffMapContext} from './DiffMapContext.jsx'

export default function Difference(props) {
    const {
        currentDifference,
        differences,
        nextDiff,
        prevDiff,
    } = useDiffMapContext()

    if (0 < differences.length) {
        return (
            <div {...props}>
                <Button
                    type="link"
                    onClick={prevDiff}
                >
                    <LeftOutlined />
                    前一处不同
                </Button>

                {currentDifference + 1} / {differences.length}

                <Button
                    type="link"
                    onClick={nextDiff}
                >
                    后一处不同
                    <RightOutlined />
                </Button>
            </div>
        )
    }
    else {
        return '两张地图完全相同'
    }
}
